const TipsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M9.75 24a1.165 1.165 0 01-1.094-.75L6.79 18.395a.753.753 0 00-.431-.43L1.5 16.093a1.172 1.172 0 010-2.188l4.856-1.867a.754.754 0 00.431-.431l1.87-4.858a1.172 1.172 0 012.187 0l1.868 4.857a.754.754 0 00.43.43l4.829 1.858a1.195 1.195 0 01.78 1.13 1.164 1.164 0 01-.75 1.07l-4.857 1.867a.754.754 0 00-.43.43l-1.87 4.858A1.164 1.164 0 019.75 24zM4.125 8.25a.688.688 0 01-.642-.44l-.79-2.056a.341.341 0 00-.197-.197L.44 4.767a.688.688 0 010-1.284l2.055-.79a.343.343 0 00.197-.197L3.476.459a.703.703 0 01.566-.454.688.688 0 01.725.436l.79 2.055a.343.343 0 00.197.197l2.056.79a.688.688 0 010 1.284l-2.056.79a.341.341 0 00-.197.197l-.79 2.055a.688.688 0 01-.642.441zM18.75 12a.75.75 0 01-.7-.48l-1.07-2.784a.374.374 0 00-.216-.215L13.981 7.45a.75.75 0 010-1.4l2.783-1.07a.375.375 0 00.216-.216L18.043 2a.771.771 0 01.617-.496.75.75 0 01.79.476l1.071 2.783a.374.374 0 00.216.216l2.783 1.07a.75.75 0 010 1.4l-2.783 1.07a.375.375 0 00-.216.216l-1.07 2.783a.75.75 0 01-.7.481z"
      ></path>
    </svg>
  );
};

export default TipsIcon;
